import {
  IconBrowser,
  IconUsers,
  IconCalendarEvent,
  IconLayoutKanban,
  IconAddressBook,
  IconRobotFace,
  IconEdit,
  IconSend,
} from '@tabler/icons-react';
import { NavItemType } from 'types';
import { getDynamicExternalApps } from './dynamic-external-apps';

// constant
const icons = {
  IconBrowser,
  IconUsers,
  IconAddressBook,
  IconCalendarEvent,
  IconLayoutKanban,
  IconRobotFace,
  IconEdit,
  IconSend,
};

// פונקציה שמחזירה את התפריט הצדדי עם אפליקציות חיצוניות דינמיות
const getViewsPages = (): NavItemType => {
  const staticItems = [
    {
      id: 'contacts',
      title: 'sidebar.nav.contacts',
      icon: icons.IconAddressBook,
      type: 'item',
      url: '/contacts/chat',
    },
    {
      id: 'docSign',
      title: 'חתימה דיגיטלית',
      icon: icons.IconEdit,
      type: 'item',
      url: '/docs-sign',
    },
  ];

  // הוספת אפליקציות חיצוניות דינמיות
  const dynamicExternalApps = getDynamicExternalApps();

  return {
    id: 'sidebar-pages',
    title: 'sidebar.nav.additionalPages',
    // caption: 'sidebar.nav.additionalPages',
    type: 'group',
    children: [
      ...staticItems,
      ...dynamicExternalApps,
      // {
      //   id: 'users',
      //   title: 'sidebar.nav.users',
      //   icon: icons.IconUsers,
      //   type: 'item',
      //   url: '/users',
      // },
      // {
      //   id: 'kanban',
      //   title: 'sidebar.nav.kanban',
      //   icon: icons.IconLayoutKanban,
      //   type: 'item',
      //   url: '/kanban/board',
      // },
    ],
  };
};

const viewsPages: NavItemType = getViewsPages();

export default viewsPages;
